import React, { useEffect, useState } from "react";
import { useAuthUser } from 'react-auth-kit';
import axios from "../api/axios";
import { useAuthHeader } from "react-auth-kit";
import Navbarespaceperso from "../components/Navbarespaceperso";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Select, MenuItem, TextField, FormControl, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '20px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

function Espace_Admin() {
  const authUser = useAuthUser();
  const isMobile = useMediaQuery('(max-width:600px)'); // Adjust breakpoint as needed

  if (authUser() && authUser().role === 'admin') {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [equipes, setEquipes] = useState([]);
    const [equipeDelete, setEquipeDelete] = useState("");
    const [open, setOpen] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [severity, setSeverity] = useState("success");
    const [selectedSport, setSelectedSport] = useState("");
    const [valpayement, setValPayement] = useState("");
    const authHeader = useAuthHeader();
    const config = { headers: { Authorization: authHeader() } };

    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpen(false);
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(`/equipe/`, config);
          setEquipes(response.data.team);
          setLoading(false);
        } catch (error) {
          console.error("Erreur lors de la récupération des équipes:", error);
        }
      };

      fetchData();
    }, []);

    const handleSelectedSport = (event) => {
      setSelectedSport(event.target.value);
    };

    const handleEquipeDelete = (event) => {
      setEquipeDelete(event.target.value);
    };

    const handleValPayement = (event) => {
      setValPayement(event.target.value);
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
      const response = await axios.post(
        `/equipe/deleteTeam`,
        { id_team: equipeDelete },
        config
      );

      if (response.status === 201) {
        setErrMsg(`Equipe supprimée`);
        setSeverity("success");
        setOpen(true);
        setEquipeDelete("");
      } else {
        console.error("Erreur lors de la suppression de l'équipe:", error);
      }
    };

    const handleSubmitPayement = async (event) => {
      event.preventDefault();
      const response = await axios.patch(
        `/equipe/valPayement`,
        { id: valpayement },
        config
      );

      if (response.status === 201) {
        setErrMsg(`Payement Validé`);
        setSeverity("success");
        setOpen(true);
        setValPayement("");
      } else {
        console.error("Erreur lors de la validation du payement:", error);
      }
    };

    const sportsUniques = [...new Set([...equipes.map(item => item.sport), ...equipes.map(item => item.sport_2)])];
    const equipesTriees = [...equipes].sort((a, b) => a.name.localeCompare(b.name));

    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'rgba(58, 29, 29, 0.1)',
        backgroundImage: `
          repeating-linear-gradient(to right,
            rgba(0, 0, 0, 0) 0%, 
            rgba(0, 0, 0, 0) calc(50% - 1px), 
            #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
            rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
          )
        `,
        backgroundSize: 'calc(100% / 5) 100%',
        p: isMobile ? 2 : 4,
      }}>
        <Navbarespaceperso />
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
            {errMsg}
          </Alert>
        </Snackbar>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 10 }}>
          <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#96013C', marginBottom: '3rem', fontSize: isMobile ? '1.5rem' : '2rem' }}>
            Liste des équipes
          </Typography>
          {loading ? (
            <Typography variant="h6">Chargement...</Typography>
          ) : equipes.length > 0 ? (
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell>Nom</TableCell>
                    <TableCell>Prénom</TableCell>
                    <TableCell>Téléphone</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Profil</TableCell>
                    <TableCell>Pack</TableCell>
                    <TableCell>Sport</TableCell>
                    <TableCell>Sport 2</TableCell>
                    <TableCell>Paiement</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {equipes.map((equipe, index) => (
                    <TableRow key={equipe.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                      <TableCell>{equipe.id}</TableCell>
                      <TableCell>{equipe.name}</TableCell>
                      <TableCell>{equipe.firstname}</TableCell>
                      <TableCell>{equipe.phonenumber}</TableCell>
                      <TableCell>{equipe.email}</TableCell>
                      <TableCell>{equipe.profile}</TableCell>
                      <TableCell>{equipe.pack}</TableCell>
                      <TableCell>{equipe.sport}</TableCell>
                      <TableCell>{equipe.sport_2}</TableCell>
                      <TableCell>{equipe.payement}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="h6" color="error">Pas d'équipe</Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'center', alignItems: 'center', gap: '3rem', flexWrap: 'wrap', mt: 4 }}>
          <Box sx={{ width: isMobile ? '100%' : '40%' }}>
            <form onSubmit={handleSubmit}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <CustomFormControl fullWidth>
                  <Select
                    value={equipeDelete}
                    onChange={handleEquipeDelete}
                    displayEmpty
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">- Supprimer une équipe -</MenuItem>
                    {equipes.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name} {item.firstname}
                      </MenuItem>
                    ))}
                  </Select>
                </CustomFormControl>
                <Button
                  sx={{
                    backgroundColor: '#96013C',
                    color: 'white',
                    padding: '10px 35px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginTop: '1rem',
                    '&:hover': {
                      backgroundColor: '#96013C',
                    },
                  }}
                  type="submit">
                  Supprimer
                </Button>
              </Box>
            </form>
          </Box>

          <Box sx={{ width: isMobile ? '100%' : '40%' }}>
            <form onSubmit={handleSubmitPayement} >
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <CustomFormControl fullWidth>
                  <Select
                    value={valpayement}
                    onChange={handleValPayement}
                    displayEmpty
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">- Valider un paiement -</MenuItem>
                    {equipesTriees.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name} {item.firstname}
                      </MenuItem>
                    ))}
                  </Select>
                </CustomFormControl>
                <Button
                  sx={{
                    backgroundColor: '#96013C',
                    color: 'white',
                    padding: '10px 35px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginTop: '1rem',
                    '&:hover': {
                      backgroundColor: '#96013C',
                    },
                  }}
                  type="submit">
                  Valider
                </Button>
              </Box>
            </form>
          </Box>

          <Box sx={{ width: isMobile ? '100%' : '40%' }}>
            <form onSubmit={handleSelectedSport}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <CustomFormControl fullWidth>
                  <Select
                    value={selectedSport}
                    onChange={handleSelectedSport}
                    displayEmpty
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">- Sélectionner un sport -</MenuItem>
                    {sportsUniques.map((sport, index) => (
                      <MenuItem key={index} value={sport}>
                        {sport}
                      </MenuItem>
                    ))}
                  </Select>
                </CustomFormControl>
                <Button
                  sx={{
                    backgroundColor: '#96013C',
                    color: 'white',
                    padding: '10px 35px',
                    borderRadius: '20px',
                    fontWeight: 'bold',
                    marginTop: '1rem',
                    '&:hover': {
                      backgroundColor: '#96013C',
                    },
                  }}
                  type="submit">
                  Valider
                </Button>
              </Box>
            </form>
          </Box>
        </Box>

        <Box sx={{ mt: 4, mb: 8 }}>
          {selectedSport && (
            <Box>
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#96013C', textAlign:'center', marginBottom: '3rem', fontSize: isMobile ? '1.5rem' : '2rem' }}>
                Liste des équipes en {selectedSport}
              </Typography>
              {loading ? (
                <Typography variant="h6">Chargement...</Typography>
              ) : equipes.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Nom</TableCell>
                        <TableCell>Prénom</TableCell>
                        <TableCell>Téléphone</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Profil</TableCell>
                        <TableCell>Pack</TableCell>
                        <TableCell>Sport</TableCell>
                        <TableCell>Sport 2</TableCell>
                        <TableCell>Paiement</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {equipes.filter(equipe => equipe.sport === selectedSport || equipe.sport_2 === selectedSport)
                        .map((equipe, index) => (
                          <TableRow key={equipe.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                            <TableCell>{equipe.id}</TableCell>
                            <TableCell>{equipe.name}</TableCell>
                            <TableCell>{equipe.firstname}</TableCell>
                            <TableCell>{equipe.phonenumber}</TableCell>
                            <TableCell>{equipe.email}</TableCell>
                            <TableCell>{equipe.profile}</TableCell>
                            <TableCell>{equipe.pack}</TableCell>
                            <TableCell>{equipe.sport}</TableCell>
                            <TableCell>{equipe.sport_2}</TableCell>
                          <TableCell>{equipe.payement}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="h6" color="error">Pas d'équipe</Typography>
              )}
            </Box>
          )}
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ textAlign: 'center', mt: 5 }}>
        <Typography variant="h4" color="error">Accès refusé</Typography>
      </Box>
    );
  }
};

export default Espace_Admin;
